import {eq, gtZero} from '@shared/helpers/lang'

import {CouponDiscount, CouponProvider, DiscountCoupon} from '@web/core/constants'
import {OrderSheetCouponState} from '@web/slices/orderSheetCoupon/slice'
import makeSlice from '@web/slices/orderSheetCoupon/sliceMaker'

import {initOrderSheetByAPI} from '../../actions/familyPay'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
            const {
                data: {products},
            } = payload

            state.discount.productItem = products.reduce<OrderSheetCouponState['discount']['productItem']>(
                (acc, product) => {
                    const productTotalDiscountAmount = product.totalOrderAmount - product.totalPayAmount
                    if (gtZero(productTotalDiscountAmount)) {
                        product.items.forEach(({productOrderNo, orderAmount, payAmount, productClassType}) => {
                            const itemDiscountAmount = orderAmount - payAmount
                            if (gtZero(itemDiscountAmount)) {
                                if (eq(productClassType, 'SUPPLEMENTED')) {
                                    acc[productOrderNo] = [
                                        {
                                            baseAmount: orderAmount,
                                            discountAmount: itemDiscountAmount,
                                            // 추가상품에 할인이 적용가능한 건 스토어쿠폰밖에 없으므로 패밀리결제에서 임의표시
                                            discountType: CouponDiscount.STORE_DISCOUNT,
                                            discountProviderType: CouponProvider.SELLER,
                                            couponType: DiscountCoupon.STORE_DISCOUNT,
                                        },
                                    ]
                                } else {
                                    acc[productOrderNo] = [
                                        {
                                            baseAmount: orderAmount,
                                            discountAmount: itemDiscountAmount,
                                            // 할인금액이 중요하기 때문에 쿠폰 값을 임의의 값
                                            discountType: CouponDiscount.PRODUCT_DISCOUNT,
                                            discountProviderType: CouponProvider.MANAGER,
                                            couponType: DiscountCoupon.MANAGER_PRODUCT_DISCOUNT,
                                        },
                                    ]
                                }
                            }
                        })
                    }
                    return acc
                },
                {},
            )
        })
    },
})

export default slice.reducer
